import { render, staticRenderFns } from "./DetailsAddons.vue?vue&type=template&id=20f15e2c&scoped=true&"
import script from "./DetailsAddons.vue?vue&type=script&lang=js&"
export * from "./DetailsAddons.vue?vue&type=script&lang=js&"
import style0 from "./DetailsAddons.vue?vue&type=style&index=0&id=20f15e2c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f15e2c",
  null
  
)

export default component.exports